import { Injectable, inject } from "@angular/core";
import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { LocationData } from "../../interfaces/marker-data.interface";
import { ResponseContainer } from "../../interfaces/response-container.interface";

@Injectable({
  providedIn: "root",
})
export class MapService {
  private baseApiService = inject(BaseApiService);
  private http = inject(HttpClient);

  async GetLocations(): Promise<LocationData[]> {
    const response = await lastValueFrom(
      this.http.get<ResponseContainer<LocationData[]>>(
        `${this.baseApiService.rootUrl}/back-office/maps/locations`,
      ),
    );
    return response.data;
  }
}
